import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import landingPageQuery from './query.graphql';

const ShopOfTheYearLandingPage = loadable(
  () =>
    import(
      /* webpackChunkName: "shop-of-the-year" */
      './components/landing-page'
    ),
  {
    fallback: <Loader />,
  }
);

ShopOfTheYearLandingPage.graphQL = landingPageQuery;

ShopOfTheYearLandingPage.variables = ({ section }) => {
  return { section };
};

export { ShopOfTheYearLandingPage };
